import React, { FC, SVGProps } from 'react';

type CrossIconProps = SVGProps<SVGSVGElement> & {
  className?: string;
};

import './CrossIcon.scss';

const CrossIcon: FC<CrossIconProps> = ({ className = '', ...otherProps }: CrossIconProps) => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...otherProps}
  >
    <path
      id="primary"
      d="M13.41,12l6.3-6.29a1,1,0,1,0-1.42-1.42L12,10.59,5.71,4.29A1,1,0,0,0,4.29,5.71L10.59,12l-6.3,6.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l6.29,6.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
      fill="#ff4a4a"
    />
  </svg>
);

export default CrossIcon;
